import { observer } from 'mobx-react';
import { Flex } from '../UI/Flex/Flex';
import * as style from './ModalNewResearch.module.less';
import { observable } from 'mobx';
import { useState } from 'react';
import right_art from './modal.png';
import { Split } from '../Split/Split';
import classNames from 'classnames';
import { Button } from 'react-bootstrap';
import { getFirebase } from '@assets/firebase/FirebaseAdapater';
import { useStoreUI } from '@assets/model/Store';

class NewResearchStore {
    constructor() {}

    @observable
    accessor company_name: string = '';

    @observable
    accessor industry: string = '';

    @observable
    accessor website: string = '';
}

export const ModalNewResearch = observer(() => {
    const [store] = useState(new NewResearchStore());
    const create_textbox = (label: string, field: keyof NewResearchStore) => {
        return (
            <div>
                <label className={style.label}>{label}</label>
                <input
                    type="text"
                    className={style.input_text}
                    value={store[field]}
                    onInput={e => {
                        store[field] = e.currentTarget.value;
                    }}
                    placeholder={label}
                />
            </div>
        );
    };

    const create_textarea = (label: string, field: keyof NewResearchStore) => {
        return (
            <div>
                <label className={style.label}>{label}</label>
                <textarea
                    rows={3}
                    className={classNames(
                        style.input_text,
                        style.input_textarea
                    )}
                    value={store[field]}
                    onInput={e => {
                        store[field] = e.currentTarget.value;
                    }}
                    placeholder={label}
                />
            </div>
        );
    };

    const onAddResarch = () => {
        const fb = getFirebase();
        fb.add_research_job(
            'Research',
            store.company_name,
            store.industry,
            store.website
        );
        const uiStore = useStoreUI();
        uiStore.modal = null;
    };

    const canAddJob =
        store.company_name.trim().length > 0 &&
        store.industry.trim().length > 0 &&
        store.website.trim().length > 0;
    const elements = [];
    elements.push(create_textbox('Company Name', 'company_name'));
    elements.push(create_textarea('Industry', 'industry'));
    elements.push(create_textbox('Website', 'website'));
    elements.push(<div style={{ flex: 1 }}></div>);
    elements.push(
        <Button
            variant="light"
            className={style.addButton}
            onClick={onAddResarch}
            disabled={!canAddJob}
        >
            Add New Research
        </Button>
    );

    return (
        <Split layoutPercent={[50, 50]} spaceBetween={40}>
            <Flex fillCell={true} direction="column">
                {elements}
            </Flex>
            <Flex fillCell={true} direction="column">
                <img src={right_art} className={style.rightImage} />
            </Flex>
        </Split>
    );
});
